import {
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILED,
  SET_SELECTED_USER,
} from './actionTypes';

const initialState = {
  data: [],
  loading: false,
  error: null,
  meta: {
    search: '',
    sort: null,
    order: null,
    perPage: 10,
    page: 1,
    lastPage: 1,
  },
  userId: null,
};

const assignTableReducer = (state = initialState, {
  type, error, data, meta, userId,
}) => {
  switch (type) {
    case GET_USERS_REQUEST:
      return { ...state, loading: true };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        data: data.map((i) => ({ ...i, _selected: false })),
        meta: {
          search: meta.search,
          page: meta.current_page,
          lastPage: meta.last_page,
          order: meta.order,
          sort: meta.sort,
          perPage: meta.per_page,
        },
        loading: false,
      };
    case GET_USERS_FAILED:
      return { ...state, loading: false, error };
    case SET_SELECTED_USER:
      return {
        ...state,
        userId,
        data: state.data.map((i) => ({ ...i, _selected: userId === i.id })),
        loading: false,
      };
    default:
      return state;
  }
};

export default assignTableReducer;
